import * as actionTypes from "../actions/types";
import CatalogoService from "../services/catalogo";

export const setPrestadorActivo = (objeto) => (dispatch) => {
    dispatch({
        type: actionTypes.SET_PRESTADOR_ACTIVO,
        payload: objeto,
    });
};

export const setToken = (token) => (dispatch) => {
    dispatch({
        type: actionTypes.SET_TOKEN,
        payload: token,
    });
};

export const getInformacionUsuario = () => (dispatch, getState) => {
    CatalogoService.userInfo().then((response) => {
        const _codPrestador = response.data.codPrestador;

        const _prestador = response.data.codigos.find(
            (cod) => cod.codPrestador === _codPrestador
        );

        response.data.tipoPresentacion = _prestador
            ? _prestador.tipoPresentacion
            : false;

        response.data.obraSocial = _prestador
            ? _prestador.obraSocial
            : false;

        sessionStorage.setItem(
            "prestadorActivo",
            JSON.stringify(response.data)
        );

        sessionStorage.setItem("token", getState().authReducer.token);

        dispatch(setPrestadorActivo(response.data));
    });
};
